const faqs = [
  {
    q: '西瓜影视需要付费吗？',
    a: '西瓜影视提供大量免费高清影视内容供用户在线观看，无需付费即可享受蓝光超清画质和流畅不缓冲的播放体验。我们通过广告合作维持运营，始终坚持以用户为中心的免费策略。',
  },
  {
    q: '支持哪些设备观看？',
    a: '西瓜影视全面支持电脑、平板、手机等主流设备访问，兼容Chrome、Safari、Edge等浏览器。同时我们提供移动端专属应用，在iOS和Android平台均可下载使用，随时随地畅享高清影视。',
  },
  {
    q: '视频加载慢或卡顿怎么办？',
    a: '西瓜影视采用智能CDN加速和自适应码率技术，会根据您的网络状况自动调整画质。如遇卡顿，建议检查网络连接或尝试切换清晰度。电信、联通、移动等主流网络均已深度优化，确保流畅不缓冲的播放体验。',
  },
  {
    q: '影片资源多久更新一次？',
    a: '我们拥有专业的内容运营团队，热门电影电视剧上映后24小时内即可上线。综艺节目和动漫番剧当天同步更新，片库每日都有新内容加入，确保您不会错过任何精彩。',
  },
  {
    q: '如何反馈影片问题或建议？',
    a: '您可以通过页面底部的联系方式发送邮件给我们，或在#contact区域找到投稿与合作邮箱。如发现影片播放异常、字幕错误等问题，欢迎随时反馈，我们的技术团队会在第一时间处理。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              关于西瓜影视的使用，您可能想了解的问题都在这里
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-background-100 rounded-xl p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-3 flex items-start gap-3">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {faq.q}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-8">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}